import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App.tsx'
import './index.css'

Sentry.init({
  dsn: "https://b3edf481b013d261e8c4d44f91c9c690@o4511149040205824.ingest.de.sentry.io/4511149050626128",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
      gcTime: 1000 * 60 * 30, // Keep unused data in cache for 30 minutes
      retry: 1, // Retry failed requests once
      refetchOnWindowFocus: true, // Refetch when user comes back to tab
    },
    mutations: {
      retry: 0, // Don't retry mutations by default
    },
  },
})

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
    <ReactQueryDevtools
      initialIsOpen={false}
      position="bottom"
    />
  </QueryClientProvider>
);
